// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SingleSignOn_sso__8JTPN {
	display: flex;
	width: 155px;
	/* padding: 19px 0 19px 0; */
	height: 61px;
	gap: 16px;
}

.SingleSignOn_sso_style__EfX\\+P {
	border-radius: 5px;
	border: 1px solid var(--neutral-colors-500, #e0e0e9);
	background: var(--neutral-colors-white, #fff);
}

.SingleSignOn_sso_icon__ja3xI {
	flex-shrink: 0;
}

.SingleSignOn_greyed__DUGRT {
	background: var(--neutral-colors-white, #e0e0e9) !important;
}

.SingleSignOn_sso_icon_apple_style__uGpiR {
	width: 19.373px;
	height: 23px;
	fill: var(--brand-colors-apple, #000);
}

.SingleSignOn_sso_icon_google_style__GrtjI {
	width: 23px;
	height: 23px;
}

.SingleSignOn_sso_icon_microsoft_style__11Hgm {
	width: 26px;
	height: 26px;
}

.SingleSignOn_ssoTxt__y0XQy {
	color: var(--neutral-colors-black, #1d1c2b);
	font-feature-settings: 'clig' off, 'liga' off;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px; /* 125% */
}

/* -----------------Media-Queries---------------------- */
@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {
}

@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {
	.SingleSignOn_sso__8JTPN {
		width: 140px;
	}
}

@media only screen and (max-width: 820px) {
	/* .ssoTxt:not(.ssoTxt.fill) {
		display: none !important;
	} */
}

@media only screen and (max-width: 820px) and (min-height: 441px) {
}

@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {
}

@media only screen and (max-width: 480px) {
	.SingleSignOn_ssoTxt__y0XQy:not(.SingleSignOn_ssoTxt__y0XQy.SingleSignOn_fill__87tgA) {
		display: none !important;
	}

	.SingleSignOn_sso_style__EfX\\+P {
		width: 98px;
		height: 58px;
	}
}

@media only screen and (max-width: 480px) and (min-width: 361px) {
}

@media only screen and (max-width: 360px) {
	.SingleSignOn_ssoTxt__y0XQy {
		display: none !important;
	}
}

@media only screen and (max-width: 360px) and (min-width: 301px) {
}

@media only screen and (max-width: 300px) {
}
`, "",{"version":3,"sources":["webpack://./src/styles/SingleSignOn.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,YAAY;CACZ,4BAA4B;CAC5B,YAAY;CACZ,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,oDAAoD;CACpD,6CAA6C;AAC9C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,2DAA2D;AAC5D;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,qCAAqC;AACtC;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,2CAA2C;CAC3C,6CAA6C;CAC7C,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA,yDAAyD;AACzD;AACA;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;;IAEG;AACJ;;AAEA;AACA;;AAEA;AACA;;AAEA;CACC;EACC,wBAAwB;CACzB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;AACD;;AAEA;AACA;;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".sso {\n\tdisplay: flex;\n\twidth: 155px;\n\t/* padding: 19px 0 19px 0; */\n\theight: 61px;\n\tgap: 16px;\n}\n\n.sso_style {\n\tborder-radius: 5px;\n\tborder: 1px solid var(--neutral-colors-500, #e0e0e9);\n\tbackground: var(--neutral-colors-white, #fff);\n}\n\n.sso_icon {\n\tflex-shrink: 0;\n}\n\n.greyed {\n\tbackground: var(--neutral-colors-white, #e0e0e9) !important;\n}\n\n.sso_icon_apple_style {\n\twidth: 19.373px;\n\theight: 23px;\n\tfill: var(--brand-colors-apple, #000);\n}\n\n.sso_icon_google_style {\n\twidth: 23px;\n\theight: 23px;\n}\n\n.sso_icon_microsoft_style {\n\twidth: 26px;\n\theight: 26px;\n}\n\n.ssoTxt {\n\tcolor: var(--neutral-colors-black, #1d1c2b);\n\tfont-feature-settings: 'clig' off, 'liga' off;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 20px; /* 125% */\n}\n\n/* -----------------Media-Queries---------------------- */\n@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {\n}\n\n@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {\n\t.sso {\n\t\twidth: 140px;\n\t}\n}\n\n@media only screen and (max-width: 820px) {\n\t/* .ssoTxt:not(.ssoTxt.fill) {\n\t\tdisplay: none !important;\n\t} */\n}\n\n@media only screen and (max-width: 820px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 480px) {\n\t.ssoTxt:not(.ssoTxt.fill) {\n\t\tdisplay: none !important;\n\t}\n\n\t.sso_style {\n\t\twidth: 98px;\n\t\theight: 58px;\n\t}\n}\n\n@media only screen and (max-width: 480px) and (min-width: 361px) {\n}\n\n@media only screen and (max-width: 360px) {\n\t.ssoTxt {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media only screen and (max-width: 360px) and (min-width: 301px) {\n}\n\n@media only screen and (max-width: 300px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sso": `SingleSignOn_sso__8JTPN`,
	"sso_style": `SingleSignOn_sso_style__EfX+P`,
	"sso_icon": `SingleSignOn_sso_icon__ja3xI`,
	"greyed": `SingleSignOn_greyed__DUGRT`,
	"sso_icon_apple_style": `SingleSignOn_sso_icon_apple_style__uGpiR`,
	"sso_icon_google_style": `SingleSignOn_sso_icon_google_style__GrtjI`,
	"sso_icon_microsoft_style": `SingleSignOn_sso_icon_microsoft_style__11Hgm`,
	"ssoTxt": `SingleSignOn_ssoTxt__y0XQy`,
	"fill": `SingleSignOn_fill__87tgA`
};
export default ___CSS_LOADER_EXPORT___;
